import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const JsonLd = (thing)=>/*#__PURE__*/ React.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(swcHelpers.objectSpread({
                '@context': 'http://schema.org'
            }, thing), null, 2)
        }
    })
;

export { JsonLd };
//# sourceMappingURL=JsonLd.js.map
